import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../Baseurl";
import {
  FaFacebook,
  FaLinkedin,
  FaYoutube,
  FaInstagram,
  FaPinterest,
} from "react-icons/fa";
import logo from "../component/img/logoa.jpeg";
import { Mail, Map, MapPin, Phone } from "react-feather";


const Footer = () => {
  const [footerDetails, setFooterDetails] = useState(null);

  // Fetch existing footer details
  const fetchFooterDetails = async () => {
    try {
      const response = await axios.get(`${baseurl}getFooterDetails`);
      if (response.data && response.data.data) {
        setFooterDetails(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching footer details:", error);
    }
  };

  useEffect(() => {
    fetchFooterDetails();
  }, []);

  return (
    <footer className="footer-container">
      {/* <div className="col-md-12">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.79870207801!2d77.4566081!3d28.6357946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cee1a9284e505%3A0xfe287e2deb75c42c!2s1by%208%2C%20South%20Side%20G.T%20Rd%2C%20Sector%2013%2C%20Bulandshahr%20Road%20Industrial%20Area%2C%20Ghaziabad%2C%20Uttar%20Pradesh%20201009!5e0!3m2!1sen!2sin!4v1743449190395!5m2!1sen!2sin"
        style={{ height: "200px", width: "100%" }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
      </div> */}

      
      <div className="footer-top">
        <div className="footer-section about-store">

<div className="mb-3">
<img src={logo} className="img-fluid logo1" /> 
<span> Tech</span>
<span className="text-warning"> Spare India</span>
</div>


          <h4 className="text-start text-warning">About Our Store</h4>
          <p className="text-start">
           Tech Spares India is India’s dedicated marketplace for laboratory equipment, spare parts, and service engineers. We connect labs across the country to buy and sell used or new instruments, list spare parts, and find trusted service professionals — all in one reliable platform designed to support cost-effective and sustainable laboratory operations.
          </p>


          <div className="social-icons mt-2">
            {footerDetails?.facebook && (
              <a
                href={footerDetails.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook size={20} />
              </a>
            )}
            {footerDetails?.linkedin && (
              <a
                href={footerDetails.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin size={20} />
              </a>
            )}
            {footerDetails?.youtube && (
              <a
                href={footerDetails.youtube}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube size={20} />
              </a>
            )}
            {footerDetails?.instagram && (
              <a
                href={footerDetails.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={20} />
              </a>
            )}
            {footerDetails?.pinterest && (
              <a
                href={footerDetails.pinterest}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaPinterest size={20} />
              </a>
            )}
          </div>


        </div>



        <div className="footer-section contact-info">
          <h4 className="text-start text-warning">Address</h4>
          <ul>
            <li><MapPin size={16} className="text-warning"/>{" "}{footerDetails?.address || "Address not available"}</li>
            <li className="text-warning"><Phone size={16} className="text-warning"/> : {footerDetails?.phone || "Not available"}</li>
            <li className="text-warning">
              <Mail size={16} className="text-warning"/> :{" "}
              <a href={`mailto:${footerDetails?.email || "info@example.com"}`} className="text-warning">
                {footerDetails?.email || "info@example.com"}
              </a>
            </li>
          </ul>
          
        </div>



        {/* <div className="footer-section">
          <h4 className="text-start">Products</h4>
          <ul> 
            <li>
              <Link to="/latest-product" className="text-white">
                New Products
              </Link>
            </li>  
            <li>
              <Link to="/contact-us" className="text-white">
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/blogs" className="text-white">
                Blogs
              </Link>
            </li> 
            <li>
              <Link to="/education-training" className="text-white">
                Education & Training
              </Link>
            </li> 
          </ul>
        </div> */}


        <div className="footer-section">
          <h4 className="text-start text-warning">Quick Links</h4>
          <ul>
            <li>
            <Link to="/about-us" className="text-white">
            About Us
              </Link>
              </li> 
            <li> <Link to="/contact-us" className="text-white"> Contact Us </Link> </li> 
            <li> <Link to="/blogs" className="text-white"> Blogs </Link> </li> 
            <li> <Link to="/service-repair" className="text-white"> Service & Repair </Link> </li> 
            <li> <Link to="/education-training" className="text-white"> Education & Training </Link> </li> 
          </ul>
        </div>


        <div className="footer-section">
          <h4 className="text-start text-warning">Support</h4>
          <ul>
            {/* <li>Delivery</li> */}
            <li>
              <Link to="/legal-notice" className="text-white">
                Legal Notice
              </Link>
            </li> 
            <li>
              <Link to="/terms-and-conditions" className="text-white">
                Terms and Conditions
              </Link>
            </li>

            <li>
              <Link to="/privacy-policy" className="text-white">
                Privacy Policy
              </Link>
            </li>

            <li>
              <Link to="/shipping-policy" className="text-white">
              Shipping Policy
              </Link>
            </li>

            <li>
              <Link to="/return-policy" className="text-white">
              Return & Cancellation Policy
              </Link>
            </li>
 
            {/* <li>Secure Payment</li> */}
          </ul>
        </div>

        

        <div className="footer-section">
          <h4 className="text-start text-warning">My Links</h4>
          <ul>
            <li>
            <Link to="/customer/login" className="text-white">
            Your Account
              </Link>
              </li> 
            <li>
              <Link to="/cart" className="text-white">
                Cart
              </Link>
            </li> 
          </ul>
        </div>
        
      </div>
      <div className="footer-bottom">
        <p>© 2025 All Rights Reserved by techsparesindia.com</p>
      </div>
    </footer>
  );
};

export default Footer;
